import styled from 'styled-components';
import color from '../../configs/color';
import thumbStyle from '../../configs/thumbStyle';

const Wrapper = styled.div`
  background-color: white;
  height: 100%;
  width: 100%;
  margin: 0;
  margin-top: 50px;
  border-radius: 0;
  max-width: unset;

  .component_features_header_options {
    width: 222px;
  }

  .component_features_header {
    /* text-align: center; */
    .component_features_header-title {
      height: 44px;
      line-height: 44px;
      margin-right: 24px;
    }
    margin-bottom: 24px;
    .component_features_header_title {
      color: ${color.black1};
      margin-bottom: 32px;
    }
    .component_features_header_tabmenu {
      margin-bottom: 73px;
      .font-paragraph_medium {
        transition: 0.3s ease;
        :hover {
          background-color: transparent;
          border-color: ${color.green1};
        }
        &.active {
          background-color: ${color.green1};
          border-color: ${color.green1};
          color: ${color.grey5};
        }
      }
    }
  }

  .component_features_pricing {
    max-width: 1200px;
    margin: auto;
    overflow-x: auto;
    overflow-y: hidden;
    height: auto;
    ${thumbStyle};
    margin-bottom: 120px;
    .component_features_pricing_list {
      display: grid;
      grid-template-columns: repeat(3, 378px);
      align-items: flex-start;
      column-gap: 33px;
    }
  }

  .component_features_compare {
    max-width: 1200px;
    margin: auto;
    overflow-x: auto;
    overflow-y: hidden;
    height: auto;
    padding-bottom: 154px;
    .component_features_compare_header {
      text-align: center;
      margin-bottom: 60px;
      .component_features_header_title {
        color: ${color.black1};
      }
      .component_features_header_subtitle {
        color: ${color.black3};
      }
    }
    .component_features_compare_body {
      color: ${color.black1};
      font-weight: 600;
      .component_column_value > div {
        color: ${color.black3};
      }
      .component_column_value_icon {
        color: ${color.green1};
        font-size: 24px;
      }
      .ant-table {
        padding: 0;
        box-shadow: none;
        font-size: 20px;
        tbody tr {
          :first-child > td:not(:first-child) {
            text-align: center;
          }
          :not(:first-child) td:not(:first-child) {
            text-align: center;
            font-size: 18px;
          }
        }
      }
    }
  }
`;

export default Wrapper;

export const PricingItemWrapper = styled.div`
  .container_pricing_item_box {
    padding: 36px;
    border-radius: 12px;
    border: 1px solid ${color.grey1};
    background-image: ${(props) => {
      return `url(${props.bgImage})`;
    }};
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 32px;
  }

  .component_pricing_item_header {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    margin-bottom: 24px;
    min-height: 96px;
    > div:first-child {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      .component_pricing_item_header_title {
        color: ${(props) => {
          return props.bgImage ? color.grey5 : color.black1;
        }};
      }
      .component_pricing_item_header_subtitle {
        color: ${color.green1};
        text-align: right;
      }
    }
    .component_pricing_item_header_desc {
      color: ${(props) => {
        return props.bgImage ? color.grey5 : color.black3;
      }};
    }
  }

  .component_pricing_item_body {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    height: 128px;
    margin-bottom: 24px;
    .component_pricing_item_body_currency {
      color: ${color.black3};
    }
    .component_pricing_item_body_price,
    .component_pricing_item_lets {
      color: ${(props) => {
        return props.primaryColor;
      }};
      font-weight: 700;
      font-size: 44px;
      line-height: 57.2px;
    }
    .component_pricing_item_lets {
      margin-top: 38px;
    }
    .component_pricing_item_body_time {
      color: ${color.black1};
    }
  }

  .component_pricing_item_footer {
    .ant-btn {
      background-color: ${(props) => {
        return props.primaryColor;
      }};
      border-color: ${(props) => {
        return props.primaryColor;
      }};
      box-shadow: ${(props) => {
        return `0px 2px 16px ${props.shadowColor}`;
      }};
      color: ${(props) => {
        return props.secondaryColor;
      }};
      :hover {
        filter: brightness(110%);
      }
    }
  }

  .container_pricing_item_information {
    .container_pricing_item_information_list {
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      row-gap: 12px;
      .container_pricing_item_information_list_item {
        color: ${color.black3};
        display: flex;
        align-items: flex-start;
        .anticon {
          color: ${color.green1};
          margin-right: 12px;
          font-size: 20px;
        }
      }
    }
  }

  .component_pricing_enterprise {
    color: ${color.white};
    .component_pricing_item_body_currency,
    .component_pricing_item_body_time {
    }
  }
`;
